// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buybox-reset-button[data-v-5ee7f297]{all:unset;cursor:pointer;padding:8px 16px;display:flex;justify-content:center;align-items:center;gap:8px;color:#62656c;font-size:14px;line-height:16px;letter-spacing:.21px}", ""]);
// Exports
module.exports = exports;
